import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import copy from 'copy-to-clipboard';
import Text from 'components/Text';
import Button from 'components/Button';
import DefaultInput from '../DefaultInput';
import { CopyInputStyled, CopyInputTopArea } from './styles/CopyInputStyled';

class CopyInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      buttonState: props.copyText,
      buttonColor: 'blue',
    };
    this.timeoutId = null;
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  onButtonClick = () => {
    const { buttonState } = this.state;
    const { copyText, copiedText, text, onCopyButtonClick } = this.props;
    if (buttonState === copyText && this.timeoutId === null) {
      copy(text);
      onCopyButtonClick?.();
      this.timeoutId = setTimeout(() => {
        this.setState({
          buttonState: copyText,
        });
        this.timeoutId = null;
      }, 3000);
      this.setState({
        buttonState: copiedText,
      });
    }
  };

  onInputClick = (event) => {
    event.currentTarget.select();
  };

  render() {
    const { buttonState } = this.state;
    const {
      text,
      titleText,
      readOnly,
      copiedText,
      textFont,
      textWeight,
      textSize,
      fixedTextSize,
      inputTextWeight,
      inputTextSize,
      theme,
    } = this.props;

    const copied = buttonState === copiedText;

    return (
      <CopyInputStyled>
        <CopyInputTopArea>
          <Text
            fixedSize={fixedTextSize}
            size={textSize}
            font={textFont}
            weight={textWeight}
            type="uppercase"
            color="gray_nightrider"
          >
            {titleText}
          </Text>
          <Button
            text={buttonState}
            onClick={copied ? null : this.onButtonClick}
            disable={copied}
            textFont={textFont}
            textSize={textSize}
            textWeight={600}
            textType="uppercase"
            buttonStyle="transparent"
            fixedTextSize={fixedTextSize}
            textColor={copied ? 'green_light' : theme.main}
            hoverColor={copied ? 'green_light' : theme.main_hover_color}
          />
        </CopyInputTopArea>
        <DefaultInput
          {...this.props}
          key={text} // this is component is very old and looks very bad, I do not want to refactor it, so just recreate it when the link is changed
          defaultValue={text}
          readOnly={readOnly}
          onInputClick={this.onInputClick}
          fontWeight={inputTextWeight}
          fontSize={inputTextSize}
          font={textFont}
        />
      </CopyInputStyled>
    );
  }
}

CopyInput.propTypes = {
  titleText: PropTypes.string,
  copyText: PropTypes.string,
  copiedText: PropTypes.string,
  readOnly: PropTypes.bool,
  text: PropTypes.string,
  textFont: PropTypes.string,
  textWeight: PropTypes.string,
  textColor: PropTypes.string,
  textSize: PropTypes.string,
  hoverColor: PropTypes.string,
  fixedTextSize: PropTypes.bool,
  inputTextWeight: PropTypes.string,
  inputTextSize: PropTypes.string,
  onCopyButtonClick: PropTypes.func,
};

CopyInput.defaultProps = {
  titleText: '',
  copyText: '',
  copiedText: '',
  readOnly: false,
  text: '',
  textFont: 'din_bold',
  textWeight: '',
  textColor: '',
  hoverColor: '',
  textSize: 'fs_s',
  fixedTextSize: false,
  inputTextSize: '',
  inputTextWeight: '',
};

export default withTheme(CopyInput);
